module.exports = __webpack_public_path__ + "static/img/pic44.1d908146.png";